/*!

=========================================================
* Druyp Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/druyp-dashboard-react
* Copyright 2024 Druyp (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/druyp-dashboard-react/blob/master/LICENSE.md)

* Coded by Druyp

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { Link, useLocation } from "react-router-dom";
import { useSearch } from "views/Contexts/SearchContext";
import { useEffect, useState } from "react";

// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Navbar,
  Nav,
  Container,
  Media,
} from "reactstrap";

const AdminNavbar = (props) => {
  const { searchQuery, updateSearchQuery, userAdminData, setUserAdminData, setToken } = useSearch();
  const [pathLocation, setPathLocation] = useState(null);
  const [validRoutes] = useState([
    '/admin/furniture-company-list',
    '/admin/cleaning-company-list',
    '/admin/tenant',
    '/admin/home_owner'
  ])
  const location  = useLocation()

  const handleInputChange = (e) => {
    updateSearchQuery(e?.target?.value);
    setPathLocation(e?.view?.location?.pathname)
    // console.log(e.view.location.pathname);
  };
  // useEffect(() => {
  //   const storedData = encryptDecryptData.decrypt(localStorage.getItem("user"))
  //   if (storedData) {
  //     setToken(storedData.token);
  //     setUserAdminData(storedData);
  //   }
  // }, [userAdminData]);
  useEffect(() => {
    switch (pathLocation) {
      case "/admin/tenant":
        // make Contexts file this data got in Contexts
        break;

      default:
        break;
    }

  }, [pathLocation, searchQuery]);
const handleLogout = (e) => {
  e.preventDefault();
  localStorage.removeItem("user");
  setToken(null);
  setUserAdminData(null);
  window.location.href = "/auth/login";
}



  return (
    <>
      <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
        <Container fluid>
          <Link
            className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block"
            to="/"
          >
            {props.brandText}
          </Link>
          {validRoutes.some(route => location.pathname.startsWith(route)) &&
            <Form className="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
              <FormGroup className="mb-0">
                <InputGroup className="input-group-alternative">
                  <Input placeholder="Search" type="text" onClick={handleInputChange} />
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fas fa-search" />
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </FormGroup>
            </Form>
           }
          
          <Nav className="align-items-center d-none d-md-flex" navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle">
                    <img
                      alt="..."
                      src={require("../../assets/img/theme/team-1-800x800.png")}
                    />
                  </span>
                  <Media className="ml-2 d-none d-lg-block">
                    <span className="mb-0 text-sm font-weight-bold">
                      {userAdminData?.firstName} {userAdminData?.lastName}
                    </span>
                  </Media>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-single-02" />
                  <span>My profile</span>
                </DropdownItem>
                {/* <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-settings-gear-65" />
                  <span>Settings</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-calendar-grid-58" />
                  <span>Activity</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-support-16" />
                  <span>Support</span>
                </DropdownItem> */}
                <DropdownItem divider />
                <DropdownItem href="#pablo" onClick={handleLogout}>
                  <i className="ni ni-user-run" />
                  <span>Logout</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};

export default AdminNavbar;
